import CareerTargetCard from "@Components/game/career/career-target-card";
import { useCareerContext } from "@Context/game/career/career-context";
import useI18n from "@i18n";
import { Box, Stack, Typography, useTheme } from "@mui/material";

const CareerTargets = () => {
  const { i18n } = useI18n();
  const theme = useTheme();
  const { metricScores } = useCareerContext();

  return (
    <Stack spacing={3} alignItems="flex-start">
      <Typography variant="text1xl700" color="dsBase.v200">
        {i18n("career.targets.title")}
      </Typography>
      <Box display="grid" gridTemplateColumns="repeat(5, 1fr)" gap={theme.spacing(2)} width="100%">
        {metricScores.map((ms) => {
          const { metric, score } = ms;
          if (!score) return null;
          return <CareerTargetCard key={metric} metric={metric} score={score} />;
        })}
      </Box>
    </Stack>
  );
};

export default CareerTargets;
